export default "__VITE_ASSET__Pdie9224__"